import Vue from 'vue';
import {injectRootVueOptions, vrmVueModule} from '../module';
import store from '../../vue/store';

// Adds {store} to new Vue()
injectRootVueOptions({store});

// Vuex module generator
// -------
// Generates vuex modules that wrap angular services
// The exposed functions of the service become actions
// When dispatching to them pass an array containing the arguments
// The values of the service are exposed on the state object
// The modules are strongly namespaced to the name of the service

const targets = [
    'MfaService',
    'InstallationGroupsService',
    'UserGroupsService',
    'AttributesService',
    'FirmwareLibraryService',
    'UserService',
    'ApiService'
];

vrmVueModule.run(/* @ngInject */ $injector => {
    targets.forEach(name => {
        generateVuexShim(name, $injector.get(name));
    });
});

if (Number(Vue.version.split('.')[0]) === 3) {
    alert('Fixme, vue@3 comes with breaking changes :(');
    // This is about Vue.observable() used to make the original services reactive.
    // The assumption here is that the original instance becomes reactive because vue replaces the getters and setters.
    // From vue 3.0 forward a proxy is created instead, meaning that if angular makes changes we cannot detect these yet.
    // Maybe you can do something like replace all the properties with getter/setter funcs that trigger the proxy when calling the setter.
}

function generateVuexShim(serviceName, instance) {
    const module = {
        namespaced: true,
        state: {},
        getters: {},
        mutations: {},
        actions: {},
    };
    Object.getOwnPropertyNames(instance).forEach(key => {
        const descriptor = Object.getOwnPropertyDescriptor(instance, key);
        if (descriptor.get || descriptor.set) {
            // Computed property, register as getter + mutation
            if (descriptor.get) {
                module.getters[key] = () => descriptor.get.call(instance);
            }
            if (descriptor.set) {
                module.mutations[key] = (state, arg) => descriptor.set.call(instance, arg);
            }
        } else if (typeof descriptor.value === 'function') {
            // Property is a method, register as action
            const method = descriptor.value;
            module.actions[key] = (store, args = []) => {
                return method(...args);
            }
        } else {
            // For regular props, move the property to the vuex state and wrap redirect read/writes of the original to the store
            // Copy over the existing value
            module.state[key] = descriptor.value;
            // Define a mutation for changing the value
            module.mutations[key] = (state, value) => state[key] = value;
            // Change the original property to refer to the vuex module
            // The setter uses the created mutation
            Object.defineProperty(instance, key, {
                get() {
                    return store.state[serviceName][key];
                },
                set(value) {
                    store.commit(`${serviceName}/${key}`, value);
                    return value;
                }
            });
        }
    });
    store.registerModule([serviceName], module);
}
